export interface RoleService {
  get(): string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleService = Symbol('RoleService');
